export const CHATBOT_CONFIG_FIELDS = {
  ALLOW_GEOLOCATION: 'allowGeolocation',
  CLIENT_SUPPORT: 'clientSupport',
  SEND_AUDIO: 'sendAudio',
  SEND_ATTACHMENT: 'sendAttachment',
}

const DEFAULT_VISIBLE_FIELDS = Object.values(CHATBOT_CONFIG_FIELDS)

export const getVisibleChatbotConfigFields = (templateFieldsConfig) => {
  if (!templateFieldsConfig) return new Set(DEFAULT_VISIBLE_FIELDS)

  const { add = [], exclude = [], override = [] } = templateFieldsConfig
  const base = override.length ? override : DEFAULT_VISIBLE_FIELDS

  return new Set([...base, ...add].filter(field => !exclude.includes(field)))
}
